enum FilterTypes {
  /* eslint-disable no-unused-vars */
  DateRangeInput = 1,
  MultiSelectDropDown = 2,
  /* eslint-enable no-unused-vars */
}

export default FilterTypes;
